<div class="tenant-form-container">
    <mat-card>
        <mat-card-header>
            <div class="header-content">
                <button mat-icon-button (click)="onCancel()" class="back-button">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <mat-card-title>{{ isEditMode ? 'Edit Tenant' : 'Create New Tenant' }}</mat-card-title>
            </div>
        </mat-card-header>

        <mat-card-content>
            <form [formGroup]="tenantForm" (ngSubmit)="onSubmit()">
                <!-- Row 1: Tenant Name + Business Type -->
                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Tenant Name</mat-label>
                        <input matInput formControlName="name" placeholder="Enter tenant name" required />
                        <mat-icon matPrefix>business</mat-icon>
                        <mat-error *ngIf="tenantForm.get('name')?.invalid">
                            {{ getErrorMessage('name') }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Business Type</mat-label>
                        <input matInput formControlName="business_type" placeholder="Enter business type (optional)" />
                        <mat-icon matPrefix>work</mat-icon>
                        <mat-hint>Type of business (e.g., Retail, Restaurant, Healthcare)</mat-hint>
                        <mat-error *ngIf="tenantForm.get('business_type')?.invalid">
                            {{ getErrorMessage('business_type') }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Row 2: Country + Phone -->
                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Country</mat-label>
                        <input matInput formControlName="country" placeholder="Enter country (optional)" />
                        <mat-icon matPrefix>public</mat-icon>
                        <mat-hint>Country where the tenant operates</mat-hint>
                        <mat-error *ngIf="tenantForm.get('country')?.invalid">
                            {{ getErrorMessage('country') }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone" placeholder="Enter phone number (optional)" />
                        <mat-icon matPrefix>phone</mat-icon>
                        <mat-hint>Contact phone number</mat-hint>
                        <mat-error *ngIf="tenantForm.get('phone')?.invalid">
                            {{ getErrorMessage('phone') }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Trial Ends At -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Trial End Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="trial_ends_at"
                        placeholder="Select trial end date (optional)" />
                    <mat-icon matPrefix>event</mat-icon>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-hint>Date when the trial period ends</mat-hint>
                </mat-form-field>

                <!-- Active Status -->
                <div class="form-section">
                    <mat-slide-toggle formControlName="is_active" color="accent">
                        <strong>Active Tenant</strong>
                        <small>Enable or disable this tenant</small>
                    </mat-slide-toggle>
                </div>

                <div class="info-box">
                    <mat-icon>info</mat-icon>
                    <p>
                        Inactive tenants will not be able to access the system. All associated users will
                        lose access until the tenant is reactivated.
                    </p>
                </div>

                <!-- Form Actions -->
                <div class="form-actions">
                    <button mat-raised-button type="button" (click)="onCancel()" [disabled]="loading">
                        Cancel
                    </button>
                    <button mat-raised-button color="primary" type="submit" [disabled]="loading || tenantForm.invalid">
                        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
                        <span *ngIf="!loading">{{ isEditMode ? 'Update' : 'Create' }} Tenant</span>
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>